import { render } from "./taskManagement.vue?vue&type=template&id=6a23c02c"
import script from "./taskManagement.vue?vue&type=script&lang=js"
export * from "./taskManagement.vue?vue&type=script&lang=js"

import "./taskManagement.vue?vue&type=style&index=0&id=6a23c02c&lang=less"
script.render = render

export default script